export default __webpack_public_path__ + "static/media/Img_Party_E-Hunter.30ab77b0.jpg";